const PRIMITIVE_VARIANT_REF = /^Primitives\.sizes\.variants\['([^']+)'\]$/;

function variantPx(ref, palette) {
  const variant = PRIMITIVE_VARIANT_REF.exec(ref)?.[1];
  if (!variant) {
    throw new Error(
      `font-floor: size.font alias reference "${ref}" is not a Primitives.sizes.variants reference, so its pixel size can't be compared to the floor`,
    );
  }
  const value = palette.sizes?.variants?.[variant];
  if (!/^\d+(\.\d+)?px$/.test(value ?? "")) {
    throw new Error(`font-floor: primitive size variant "${variant}" resolves to "${value}", not a pixel size`);
  }
  return parseFloat(value);
}

export function withFontFloor(theme, palette, floorVariant) {
  const floorRef = `Primitives.sizes.variants['${floorVariant}']`;
  const floorPx = variantPx(floorRef, palette);
  const fonts = theme.size?.font;
  if (!fonts) {
    throw new Error("font-floor: the theme has no size.font aliases to raise");
  }
  const raised = Object.fromEntries(Object.entries(fonts).map(([alias, ref]) => [alias, variantPx(ref, palette) < floorPx ? floorRef : ref]));
  return { ...theme, size: { ...theme.size, font: raised } };
}
